import { useEffect, useState } from 'react';
import { db, storage } from './firebaseConfig';
import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  updateDoc,
  doc
} from 'firebase/firestore';
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject
} from 'firebase/storage';
import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile } from '@ffmpeg/util';

function Formulario({ user, initialData = null, onCancel = null, onSuccess = null, selectedMembresia = 'Gratuito' }) {
  const [nombre, setNombre] = useState(initialData?.nombre || '');
  const [edad, setEdad] = useState(initialData?.edad || '');
  const [description, setDescription] = useState(initialData?.description || '');
  const [existingImages, setExistingImages] = useState(initialData?.imageUrls || []); // Fotos ya subidas
  const [images, setImages] = useState([]); // Nuevas imágenes a subir (archivos)
  const [loading, setLoading] = useState(false);
  const [yaPublico, setYaPublico] = useState(false);
  const [publicacion, setPublicacion] = useState(null);
  const [whatsapp, setWhatsapp] = useState(initialData?.whatsapp || '+569');
  const [rol, setRol] = useState(initialData?.rol || '');
  const [ciudad, setCiudad] = useState(initialData?.ciudad || '');
  const [dotacion, setDotacion] = useState(initialData?.dotacion || '');
  const [altura, setAltura] = useState(initialData?.altura || '');
  const [peso, setPeso] = useState(initialData?.peso || '');

  // Guardamos el IDENTIFICADOR de la portada. 
  // Si es existente: la URL completa.
  // Si es nueva: "new-INDEX" (ej: "new-0")
  const [portadaSelection, setPortadaSelection] = useState(initialData?.portadaUrl || '');

  const [mayorDeEdad, setMayorDeEdad] = useState(!!initialData);
  const [categoria, setCategoria] = useState(initialData?.categoria || 'Escorts');


  const comprimirImagen = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const maxWidth = 1280;
          const scale = Math.min(maxWidth / img.width, 1);
          canvas.width = img.width * scale;
          canvas.height = img.height * scale;

          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          // AGREGAR MARCA DE AGUA (Diagonal y Transparente)
          const text = "VipEncuentros.com";
          const fontSize = Math.max(24, canvas.width * 0.08); // 8% del ancho, más grande
          ctx.font = `bold ${fontSize}px Arial`;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';

          ctx.save(); // Guardar estado actual
          ctx.translate(canvas.width / 2, canvas.height / 2); // Mover al centro
          ctx.rotate(-Math.PI / 4); // Rotar -45 grados

          // Contorno suave para contraste
          ctx.lineWidth = fontSize / 20;
          ctx.strokeStyle = 'rgba(0, 0, 0, 0.3)'; // Sombra suave
          ctx.strokeText(text, 0, 0);

          // Relleno blanco transparente
          ctx.fillStyle = 'rgba(255, 255, 255, 0.4)'; // 40% opacidad
          ctx.fillText(text, 0, 0);

          ctx.restore(); // Restaurar estado (para no afectar nada más)

          canvas.toBlob((blob) => {
            const newName = file.name.replace(/\.[^/.]+$/, "") + ".webp";
            const compressedFile = new File([blob], newName, { type: 'image/webp' });
            resolve(compressedFile);
          }, 'image/webp', 0.8); // WebP tiene mejor relación calidad/peso
        };
        img.src = event.target.result;
      };
      reader.readAsDataURL(file);
    });
  };

  const comprimirVideo = async (file) => {
    return new Promise(async (resolve, reject) => {
      try {
        const ffmpeg = new FFmpeg();
        // Cargar FFmpeg desde CDN
        await ffmpeg.load({
          coreURL: "https://unpkg.com/@ffmpeg/core@0.12.10/dist/umd/ffmpeg-core.js",
          wasmURL: "https://unpkg.com/@ffmpeg/core@0.12.10/dist/umd/ffmpeg-core.wasm",
        });

        const inputName = 'inputVideo' + file.name.substring(file.name.lastIndexOf('.'));
        const outputName = 'outputVideo.mp4';

        await ffmpeg.writeFile(inputName, await fetchFile(file));

        // Comprimir a 720p y bajar crf
        await ffmpeg.exec([
          '-i', inputName,
          '-vf', 'scale=1280:-2',
          '-vcodec', 'libx264',
          '-crf', '28',
          '-preset', 'fast',
          outputName
        ]);

        const data = await ffmpeg.readFile(outputName);
        const compressedBlob = new Blob([data.buffer], { type: 'video/mp4' });
        
        const newName = file.name.replace(/\.[^/.]+$/, "") + "_compressed.mp4";
        const compressedFile = new File([compressedBlob], newName, { type: 'video/mp4' });
        
        resolve(compressedFile);
      } catch (error) {
        console.error("Error al comprimir video:", error);
        // Si falla la compresión, devolver el video original
        resolve(file); 
      }
    });
  };

  useEffect(() => {
    const verificarPublicacion = async () => {
      // Si estamos editando (initialData existe), ignoramos la verificación de "ya publicó"
      if (!user || initialData) return;

      const q = query(collection(db, 'services'), where('uid', '==', user.uid));
      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const docData = snapshot.docs[0];
        setPublicacion({ id: docData.id, ...docData.data() });
        setYaPublico(true);
      }
    };

    verificarPublicacion();
  }, [user]);

  const generarThumbnail = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const maxWidth = 350; // Tamaño pequeño para la tarjeta
          const scale = Math.min(maxWidth / img.width, 1);
          canvas.width = img.width * scale;
          canvas.height = img.height * scale;

          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height); // Sin marca de agua para el thumb, o con? Mejor sin para que se vea limpio en pequeño. 

          canvas.toBlob((blob) => {
            const newName = "thumb_" + file.name.replace(/\.[^/.]+$/, "") + ".webp";
            const thumbFile = new File([blob], newName, { type: 'image/webp' });
            resolve(thumbFile);
          }, 'image/webp', 0.75);
        };
        img.src = event.target.result;
      };
      reader.readAsDataURL(file);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let newImageUrls = [];
      let newImageFiles = []; // Guardamos los files originales comprimidos para referencia

      // 1. Subir Nuevas Imágenes/Videos
      if (images.length > 0) {
        for (const image of images) {
          let archivoProcesado;
          if (image.type.startsWith('video/')) {
            archivoProcesado = await comprimirVideo(image);
          } else {
            archivoProcesado = await comprimirImagen(image);
          }
          
          newImageFiles.push(archivoProcesado); // Guardamos para generar thumb si es necesario

          const fileRef = ref(storage, `services/${user.uid}/${Date.now()}_${archivoProcesado.name}`);
          await uploadBytes(fileRef, archivoProcesado);
          const url = await getDownloadURL(fileRef);
          newImageUrls.push(url);
        }
      }

      // 2. Combinar Listas (Existentes + Nuevas)
      const finalImageUrls = [...existingImages, ...newImageUrls];

      // 3. Determinar Portada Final y Generar Thumbnail
      let finalPortadaUrl = '';
      let finalThumbUrl = ''; // Nueva URL para la miniatura

      // Lógica para determinar el INDEX de la portada seleccionada
      let selectedNewIndex = -1;

      if (portadaSelection.startsWith('new-')) {
        // Es una de las nuevas
        selectedNewIndex = parseInt(portadaSelection.split('-')[1]);
        if (newImageUrls[selectedNewIndex]) {
          finalPortadaUrl = newImageUrls[selectedNewIndex];
        }
      } else if (portadaSelection && existingImages.includes(portadaSelection)) {
        // Es una existente
        finalPortadaUrl = portadaSelection;
        // Si es existente, ya deberíamos tener thumb o usamos la misma (no podemos generar thumb nuevo de una URL fácilmente sin descargarla)
        // Por ahora, si es existente, mantenemos el thumb existente si hay (initialData.portadaThumbUrl) 
        // O si no lo hay, usamos la misma URL (fallback actual)
        if (initialData && initialData.portadaUrl === finalPortadaUrl) {
          finalThumbUrl = initialData.portadaThumbUrl || finalPortadaUrl;
        } else {
          finalThumbUrl = finalPortadaUrl; // Fallback
        }
      }

      // Fallback: si no hay portada válida, usar la primera foto disponible
      if (!finalPortadaUrl && finalImageUrls.length > 0) {
        finalPortadaUrl = finalImageUrls[0];
        // Si es la primera y era nueva, intentamos generar thumb
        if (newImageUrls.length > 0 && finalImageUrls[0] === newImageUrls[0]) {
          selectedNewIndex = 0;
        } else {
          // Es una vieja
          finalThumbUrl = finalImageUrls[0];
        }
      }

      // Si seleccionamos una NUEVA como portada, generamos su Thumbnail
      if (selectedNewIndex !== -1 && newImageFiles[selectedNewIndex]) {
        try {
          const thumbFile = await generarThumbnail(newImageFiles[selectedNewIndex]);
          const thumbRef = ref(storage, `services/${user.uid}/thumbs/${Date.now()}_${thumbFile.name}`);
          await uploadBytes(thumbRef, thumbFile);
          finalThumbUrl = await getDownloadURL(thumbRef);
        } catch (err) {
          console.error("Error generando thumb:", err);
          finalThumbUrl = finalPortadaUrl; // Fallback a la grande
        }
      }


      const dataToSave = {
        nombre,
        edad,
        whatsapp,
        rol,
        altura,
        peso,
        dotacion,
        ciudad,
        description,
        imageUrls: finalImageUrls,
        portadaUrl: finalPortadaUrl,
        portadaThumbUrl: finalThumbUrl, // Guardamos el Thumb
        categoria,
        membresia: initialData ? initialData.membresia : selectedMembresia,
        creadoEn: initialData ? initialData.creadoEn : new Date(),
        nombreUsuario: user.displayName || 'Anónimo',
        userId: user.uid,
        aprobado: initialData ? initialData.aprobado : false,
        visible: initialData ? initialData.visible : false
      };

      if (initialData) {
        if (finalImageUrls.length === 0) {
          alert("Debes tener al menos una foto.");
          setLoading(false);
          return;
        }

        await updateDoc(doc(db, 'services', initialData.id), dataToSave);
        alert('¡Perfil actualizado con éxito!');
        if (onSuccess) onSuccess();
      } else {
        if (finalImageUrls.length === 0) {
          finalPortadaUrl = finalImageUrls[0];
        }
        await addDoc(collection(db, 'services'), dataToSave);
        alert('¡Publicación en proceso!');
        setYaPublico(true);
      }

      if (!initialData) {
        setNombre('');
        setDescription('');
        setImages([]);
        setExistingImages([]);
      }
    } catch (error) {
      console.error("Error al publicar:", error);
      alert(`Error al publicar el servicio: ${error.message}`);
    }

    setLoading(false);
  };

  const eliminarPublicacion = async () => {
    if (!publicacion) return;

    try {
      // ✅ Eliminar todas las imágenes si existen
      if (publicacion.imageUrls && publicacion.imageUrls.length > 0) {
        for (const url of publicacion.imageUrls) {
          const imagePath = new URL(url).pathname.split('/o/')[1].split('?')[0];
          const decodedPath = decodeURIComponent(imagePath);
          const imageRef = ref(storage, decodedPath);
          await deleteObject(imageRef);
        }
      }

      await deleteDoc(doc(db, 'services', publicacion.id));
      setYaPublico(false);
      setPublicacion(null);
      alert("Tu publicación fue eliminada.");
    } catch (error) {
      console.error("Error al eliminar publicación:", error);
      alert("Error al eliminar.");
    }
  };

  if (yaPublico) {
    return (
      <div className="p-4 bg-yellow-100 border border-yellow-300 rounded text-sm">
        Ya tienes una publicación activa registrada.
        <br />
        <button
          onClick={eliminarPublicacion}
          className="mt-2 text-red-600 underline"
        >
          Eliminar publicación
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="max-w-xl mx-auto flex flex-col gap-4 p-4">
      <h2 className="text-xl font-bold mb-4">Ingresa todos los datos a continuación:</h2>

      <input
        className="bg-neutral-900 text-white border border-gray-600 p-2 rounded w-full"
        placeholder="Nombre"
        value={nombre}
        onChange={(e) => setNombre(e.target.value)}
        required
      />

      <textarea
        className="bg-neutral-900 text-white border border-gray-600 p-2 rounded w-full"
        placeholder="Descripción"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        required
      />

      <input
        className="bg-neutral-900 text-white border border-gray-600 p-2 rounded w-full"
        type="number"
        min="18"
        max="99"
        placeholder="Edad"
        value={edad}
        onChange={(e) => setEdad(e.target.value)}
        required
      />

      <select
        className="bg-neutral-900 text-white border border-gray-600 p-2 rounded w-full"
        value={rol}
        onChange={(e) => setRol(e.target.value)}
        required
      >
        <option value="">Selecciona tu rol</option>
        <option value="Activo">Activo</option>
        <option value="Activo participativo">Activo participativo</option>
        <option value="Pasivo">Pasivo</option>
        <option value="Pasivo participativo">Pasivo participativo</option>
        <option value="Versátil">Versátil</option>
      </select>

      <select
        className="bg-neutral-900 text-white border border-gray-600 p-2 rounded w-full"
        value={ciudad}
        onChange={(e) => setCiudad(e.target.value)}
        required
      >
        <option value="">Selecciona tu ciudad</option>
        <option value="Santiago">Santiago</option>
        <option value="Viña del Mar">Viña del Mar</option>
      </select>

      <input
        className="bg-neutral-900 text-white border border-gray-600 p-2 rounded w-full"
        type="number"
        step="1"
        placeholder="Dotación (cm)"
        value={dotacion}
        onChange={(e) => setDotacion(e.target.value)}
      />

      <input
        className="bg-neutral-900 text-white border border-gray-600 p-2 rounded w-full"
        type="number"
        step="0.01"
        placeholder="Altura (ej: 1.70)"
        value={altura}
        onChange={(e) => setAltura(e.target.value)}
      />

      <input
        className="bg-neutral-900 text-white border border-gray-600 p-2 rounded w-full"
        type="number"
        step="1"
        placeholder="Peso (kg)"
        value={peso}
        onChange={(e) => setPeso(e.target.value)}
      />

      <div className="flex flex-col gap-1">
        <label className="text-[10px] text-gray-500 ml-1 uppercase font-bold">WhatsApp (8 dígitos tras el +569)</label>
        <input
          className="bg-neutral-900 text-white border border-gray-600 p-2 rounded w-full"
          placeholder="Contacto WhatsApp"
          value={whatsapp}
          onChange={(e) => {
            const val = e.target.value;
            // Estandarizar a +569 + 8 dígitos = 12 caracteres
            if (val.startsWith('+569')) {
              setWhatsapp(val.slice(0, 12));
            } else if (val === '') {
              setWhatsapp('+569');
            }
          }}
          required
        />
      </div>

      {/* GESTIÓN DE FOTOS EXISTENTES */}
      {existingImages.length > 0 && (
        <div className="mb-4">
          <p className="text-sm font-bold mb-2 text-gray-300">Fotos actuales:</p>
          <div className="grid grid-cols-2 gap-2">
            {existingImages.map((url, index) => (
              <div key={url} className="relative group">
                {url.includes('.mp4') || url.includes('%2Fvideo') || url.includes('video') ? (
                  <video src={url} className="w-full h-32 object-cover rounded border border-gray-700" controls muted />
                ) : (
                  <img src={url} alt={`Archivo ${index}`} className="w-full h-32 object-cover rounded border border-gray-700" />
                )}

                {/* Botón Eliminar */}
                <button
                  type="button"
                  onClick={() => {
                    const newExisting = existingImages.filter(img => img !== url);
                    setExistingImages(newExisting);
                    // Si la portada era esta, resetear
                    if (portadaSelection === url) setPortadaSelection('');
                  }}
                  className="absolute top-1 right-1 bg-red-600 text-white p-1 rounded-full shadow hover:bg-red-500"
                  title="Eliminar foto"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>

                {/* Selección de Portada */}
                <label className="absolute bottom-2 left-2 cursor-pointer">
                  <input
                    type="radio"
                    name="portada"
                    className="accent-yellow-500 scale-125"
                    checked={portadaSelection === url}
                    onChange={() => setPortadaSelection(url)}
                  />
                  <span className="ml-2 text-xs text-white bg-black/50 px-1 rounded shadow">Portada</span>
                </label>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* SUBIDA DE NUEVAS FOTOS */}
      <div className="mb-4">
        <label className="text-sm font-bold mb-2 text-gray-300 block">
          {existingImages.length > 0 ? "Agregar nuevas fotos:" : "Sube tus fotos:"}
        </label>
        <input
          type="file"
          accept="image/*,video/*"
          multiple
          onChange={(e) => {
            const files = Array.from(e.target.files);
            // Validar límite total si se desea (opcional)
            setImages([...images, ...files]);
          }}
          className="text-white text-sm bg-neutral-800 w-full p-2 rounded border border-neutral-700"
        />
        <p className="text-xs text-gray-500 mt-1">Se agregará marca de agua automáticamente.</p>
      </div>

      {images.length > 0 && (
        <div className="mt-2 grid grid-cols-2 gap-2 mb-4">
          {images.map((img, index) => (
            <div key={index} className="relative">
              {img.type.startsWith('video/') ? (
                <video
                  src={URL.createObjectURL(img)}
                  className="w-full h-32 object-cover rounded border border-gray-700"
                  controls
                  muted
                />
              ) : (
                <img
                  src={URL.createObjectURL(img)}
                  alt={`Nueva ${index + 1}`}
                  className="w-full h-32 object-cover rounded border border-gray-700"
                />
              )}

              <button
                type="button"
                onClick={() => {
                  const newImages = [...images];
                  newImages.splice(index, 1);
                  setImages(newImages);
                  // Reset portada si era esta nueva
                  if (portadaSelection === `new-${index}`) setPortadaSelection('');
                }}
                className="absolute top-1 right-1 bg-red-600 text-white p-1 rounded-full shadow hover:bg-red-500"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>

              <label className="absolute bottom-2 left-2 cursor-pointer">
                <input
                  type="radio"
                  name="portada"
                  className="accent-yellow-500 scale-125"
                  checked={portadaSelection === `new-${index}`}
                  onChange={() => setPortadaSelection(`new-${index}`)}
                />
                <span className="ml-2 text-xs text-white bg-black/50 px-1 rounded shadow">Portada</span>
              </label>
            </div>
          ))}
        </div>
      )}

      <p className="text-xs text-gray-500 mb-4">Formatos soportados: JPG, PNG, MP4. Máximo recomendado 5 archivos en total.</p>
      {/* ✅ Checkbox obligatorio */}
      <div className="flex items-start gap-2 text-sm text-gray-200">
        <input
          type="checkbox"
          id="mayorDeEdad"
          checked={mayorDeEdad}
          onChange={(e) => setMayorDeEdad(e.target.checked)}
          className="mt-1"
          required
        />
        <label htmlFor="mayorDeEdad">
          Declaro que soy mayor de 18 años y asumo total responsabilidad sobre lo que publico.
        </label>
      </div>

      <div className="bg-neutral-800 p-4 rounded-lg border border-neutral-700 mb-2">
        <label className="block text-sm font-bold mb-2 text-yellow-500">Categoría del Servicio:</label>
        <select
          className="bg-neutral-900 text-white border border-gray-600 p-2 rounded w-full"
          value={categoria}
          onChange={(e) => setCategoria(e.target.value)}
          required
        >
          <option value="Escorts">Escorts</option>
          <option value="Masajes">Masajes / Masajistas</option>
          <option value="Chicos Gay">Chicos Gay</option>
          <option value="Trans">Chicas Trans</option>
          <option value="Otros">Otros</option>
        </select>
      </div>
      <div className="flex gap-2">
        <button
          className="bg-blue-600 hover:bg-blue-500 text-white p-2 rounded flex-1 disabled:opacity-50 transition-colors"
          type="submit"
          disabled={loading}
        >
          {loading ? (initialData ? 'Guardando...' : 'Publicando...') : (initialData ? 'Guardar Cambios' : 'Publicar')}
        </button>

        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            className="bg-red-600 hover:bg-red-500 text-white p-2 rounded px-4 transition-colors"
          >
            Cancelar
          </button>
        )}
      </div>
    </form>
  );
}

export default Formulario;

